<template>
  <div class="history">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <!-- <el-date-picker
            class="inputData"
            v-model="startAndEndTime"
            type="daterange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="getDataList(true)"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker> -->
          <el-input
            style="width: 150px"
            placeholder="请输入标题内容"
            v-model.trim="queryData.keyWord"
            @keyup.enter.native="getDataList(true)"
            clearable
          >
          </el-input>
          <el-select
            v-model="queryData.status"
            class="inputS"
            placeholder="状态"
            @change="getDataList(true)"
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button class="inputR" type="primary" @click="addOrEditPopup(0)"
            >新增</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        stripe
      >
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="300">
        </el-table-column>
        <!-- <el-table-column prop="sort" label="排序" min-width="50">
        </el-table-column> -->
        <el-table-column prop="time" label="时间" min-width="150">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.time, "NYR") }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
            <el-tag type="danger" v-if="scope.row.status == 2">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="addOrEditPopup(scope.row)"
              style="marin-right: 20px"
              >编辑</el-button
            >
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="dataForm.id ? '修改' : '新增'"
      :visible.sync="centerDialogVisible"
      width="800px"
      center
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
      >
        <el-form-item prop="title" label="内容">
          <el-input
            resize="none"
            rows="3"
            type="textarea"
            v-model.trim="dataForm.title"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item prop="time" label="时间">
          <el-date-picker
            v-model.trim="dataForm.time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="sort">
          <el-input-number
            :min="1"
            placeholder="排序"
            v-model.trim="dataForm.sort"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        keyWord: "",
        status: "",
      },
      // startAndEndTime: [],
      total: 0,
      centerDialogVisible: false,
      dataForm: {},
      loadingFlag: false,
      dataFormRules: {
        title: [{ required: true, message: "请选择标题", trigger: "blur" }],
        time: [{ required: true, message: "请输入时间", trigger: "blur" }],
      },
      statusList: [
        {
          label: "启用",
          value: 1,
        },
        {
          label: "禁用",
          value: 2,
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    // 新增
    addOrEditPopup(row) {
      this.centerDialogVisible = true;
      if (row) {
        this.dataForm = JSON.parse(JSON.stringify(row));
      } else {
        this.dataForm = {
          status: 1,
        };
      }
    },
    // changeTopping(e, id) {
    //   if (e) {
    //     this.$http.post(`/news/setProductTopById?id=${id}`).then((res) => {
    //       if (res.data.code == 200) {
    //         this.getDataList();
    //       }
    //     });
    //   } else {
    //     this.$http
    //       .put(`/news/updateById`, {
    //         id,
    //         top: e,
    //       })
    //       .then((res) => {
    //         if (res.data.code == 200) {
    //           this.getDataList();
    //         }
    //       });
    //   }
    // },
    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .delete(`/kr-history/baseDeleteById/${id}`)
              .then((res) => {
                if (res.data.code == 200) {
                  this.getDataList();
                  this.$VueMessage({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$VueMessage({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 查询
    getDataList(flag) {
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        // .post(`/sys-banner/page`, this.$guolv(this.queryData))
        .get(`/kr-history/getSelectPage`, {
          params: data,
        })
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              // list.forEach((item) => {
              //   let featuresList = JSON.parse(item.features);
              //   let newFeaturesList = [];
              //   featuresList.forEach((v) => {
              //     // item.features = v.text;
              //     newFeaturesList.push(v.text);
              //     item.features = newFeaturesList.join();
              //   });
              // });
              this.tableData = list;
              this.total = data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },
    /**
      提交
     */
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "/kr-history/saveOrUpdate";
          let data = this.dataForm;
          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.getDataList();
              // this.$emit("refreshDataList");
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>